import { groq } from '#imports';

export function getQuery({ slug, offset = 0, limit = 5 } = {}) {
  return groq`*[_type == "article" && "${slug}" in crew[].staff->.slug.current && !(_id in path('drafts.**'))] | order(publishedAt desc) [${offset}..${
    offset + limit - 1
  }] {
    slug,
    crew[]{staff->, speciality->},
    image,
    title,
    subtitle,
    isArticleExternalSourceType,
    externalSource,
  }`;
}
